import { render, staticRenderFns } from "./vliveContentEdit.vue?vue&type=template&id=27f4cb06&"
import script from "./vliveContentEdit.vue?vue&type=script&lang=js&"
export * from "./vliveContentEdit.vue?vue&type=script&lang=js&"
import style0 from "./vliveContentEdit.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports